import * as angular from 'angular';
import { TileBackground, ComponentDefinition } from '../../models';

class TileController implements angular.IComponentController {
    background: TileBackground;
    hasError: boolean | null | undefined;
    hasWarning: boolean | null | undefined;
    header: string;
    isDisabled: boolean;
    style: { [prop: string]: string };
    subHeader: string | null | undefined;
    onImageClick: (value: { [key: string]: any }) => void;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['background'] && changesObj['background'].currentValue) {
            if (this.background && this.background.url) {
                this.style = {
                    'background-image': `url('${changesObj['background'].currentValue.url}')`,
                    'background-color': changesObj['background'].currentValue.color
                };
            } else {
                this.style = null;
            }
        }
    }

    onBackgroundClick($event) {
        if (this.onImageClick) {
            this.onImageClick({ event: $event });
        }
    }
}

export const wtTile: ComponentDefinition = {
    componentId: 'wtTile',
    controller: TileController,
    template: require('./tile.component.html'),
    controllerAs: 'vm',
    bindings: {
        background: '<',
        hasError: '<?',
        hasWarning: '<?',
        header: '<',
        ignoreErrors: '<?',
        isDisabled: '<?',
        isSelected: '<?',
        onImageClick: '&?',
        preventDefault: '<?',
        subHeader: '<?',
        tileHover: '=?',
        tooltip: '<?'
    },
    transclude: {
        'icons': 'tileIcons',
        'actions': '?tileActions',
        'background': '?tileBackground'
    }
};